import React from "react";
import { Container, FlexDiv, FlexSection, Box } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";
import Slider from "react-slick";
import styled from "styled-components";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
// import ReactReadMoreReadLess from "react-read-more-read-less";
// import { Heading } from "../index";
import Image from "@/components/Atoms/Image";
import { customScroll } from "@/components/Molecules/Mixin";

export const Heading = (props) => {
  const {
    title,
    mb = "16px",
    color,
    variant = "heading4",
    mobilePadding = "8px",
    isTestimonial = false,
  } = props || {};
  return (
    <HeadingWrapper mobilePadding={mobilePadding} isTestimonial={isTestimonial}>
      <FlexDiv flexDirection={"column"} mb={mb}>
        <Title my={2} color={color} variant={variant} themeColor={color}>
          {title}
        </Title>
      </FlexDiv>
    </HeadingWrapper>
  );
};

function TestimonialsV2(props) {
  const {
    data = [],
    headingColor = theme.colorsV2.success.shade_700,
    arrowImage = "arrow-new.svg",
    wrapperBG = theme.colorsV2.gray.shade_25,
    wrapperPadding = { desktop: "72px 0 42px 0", mobile: "32px 0 2px" },
    mobilePadding = "8px",
  } = props || {};
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          rows: 2,
          slidesToShow: 1,
          dots: false,
          infinite: false,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Wrapper wrapperBG={wrapperBG} wrapperPadding={wrapperPadding}>
      <TestimonialContainer>
        <Heading
          title={data.title ? data.title : "What others have to say"}
          color={headingColor}
          mb={"2px"}
          isTestimonial
          mobilePadding={mobilePadding}
        />
        <SliderWrapper maxWidth={"100%"} arrowImage={arrowImage}>
          <Slider {...settings}>
            {(data?.components || data?.testimonials || data).map(
              (data, index) => {
                return (
                  <CardWrapper bg={theme.colors.white} key={index}>
                    {data.image && (
                      <ImageBox>
                        <Image src={data.image} />
                      </ImageBox>
                    )}
                    <CardTextArea flexDirection={"column"} position="relative">
                      <Quotes
                        icon={"icon-quotes"}
                        height="16px"
                        width="24px"
                        fill={theme.colorsV2.warning.shade_300}
                      />
                      <DescriptionWrapper
                        position="relative"
                        mb={"8px"}
                        alignItems={"flex-end"}
                      >
                        <Description
                          color={theme.colorsV2.gray.shade_700}
                          variant={"paragraph2"}
                        >
                          {data?.sub_title || data?.comment}

                          {/* <ReactReadMoreReadLess
                        charLimit={250}
                        readMoreText={"Read more"}
                        readLessText={"Read less"}
                      >
                      </ReactReadMoreReadLess> */}
                        </Description>
                        <Quotes
                          icon={"icon-quotes"}
                          height="16px"
                          width="24px"
                          fill={theme.colorsV2.warning.shade_300}
                          invert={"true"}
                        />
                      </DescriptionWrapper>
                      <Typography
                        color={theme.colorsV2.gray.shade_800}
                        variant="label2"
                      >
                        {data?.title || data?.userName}
                      </Typography>
                      {/* {data?.company && (
                      <Typography
                        color={theme.colors.gray_80}
                        variant={"paragraph3"}
                      >
                        {data?.company}
                      </Typography>
                    )} */}
                    </CardTextArea>
                  </CardWrapper>
                );
              }
            )}
          </Slider>
        </SliderWrapper>
      </TestimonialContainer>
    </Wrapper>
  );
}

export default TestimonialsV2;

const Wrapper = styled(FlexSection)`
  background-color: ${({ wrapperBG }) => wrapperBG};
  padding: ${({ wrapperPadding }) => wrapperPadding.desktop};
  @media only screen and (max-width: 1079px) {
    padding: ${({ wrapperPadding }) => wrapperPadding.mobile};
  }
`;
const SliderWrapper = styled(Box)`
  margin: 0 -20px;
  .slick-prev,
  .slick-next {
    top: -35px;
    display: block !important;
    height: 32px;
    width: 32px;
    &:before {
      height: 100%;
      width: 100%;
      content: "";
      background: url(${({ arrowImage }) => `/images/${arrowImage}`}) center
        no-repeat;
      background-size: 100%;
      display: block;
    }
    @media only screen and (max-width: 1024px) {
      top: -20px;
    }
  }
  .slick-next {
    right: 8px;
  }
  .slick-prev {
    left: unset;
    right: 48px;
    &:before {
      transform: rotateY(180deg);
    }
  }
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: auto !important;
  }
  .slick-list {
    padding: 30px 0;
  }
  .slick-slide {
    > div {
      display: flex;
      height: 100%;
      margin: 0 20px;
      @media only screen and (max-width: 1024px) {
        height: unset;
        margin: 0 16px 16px;
      }
      &:last-child {
        margin: 0 16px;
      }
    }
  }
  @media only screen and (max-width: 1024px) {
    margin: 0;
  }
`;
const ImageBox = styled(FlexDiv)`
  margin-right: 8px;
  border-radius: 24px;
  overflow: hidden;
  max-width: 176px;
  max-height: 248px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    max-height: 100%;
  }
  @media only screen and (max-width: 1024px) {
    margin-right: 0;
    max-width: 30%;
  }
`;
const CardWrapper = styled(FlexDiv)`
  padding: 0;
  position: relative;
  border-radius: 24px;
  display: flex !important;
  min-height: 248px;
  outline: 0;
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colorsV2.gray.shade_100};
  box-shadow: 0px 13px 13px rgba(${theme.colors.shadows.black}, 0.02);
`;
const CardTextArea = styled(FlexDiv)`
  padding: 48px 24px 24px;
  position: relative;
  outline: 0;
  flex: 1;
`;
const Quotes = styled(StyledSvgSprite)`
  ${({ invert }) =>
    invert === "true"
      ? `
  margin-bottom: 8px;
  transform: rotate(180deg);
`
      : `
  position: absolute;
  top: 20px;
  left: 24px;
  `};
`;
const TestimonialContainer = styled(Container)`
  @media only screen and (max-width: 1024px) {
    padding-left: 0;
    padding-right: 0;
  }
`;
const DescriptionWrapper = styled(FlexDiv)`
  flex-direction: column;
  flex: 1;
`;
const Description = styled(Typography)`
  ${customScroll({})};
  max-height: 120px;
  overflow: auto;
  position: relative;
  .react-read-more-read-less {
    font-size: inherit;
    font-family: var(--font-700);
    color: ${theme.colors.link2Color};
  }
`;

const Title = styled(Typography)`
  padding-left: 28px;
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 8px;
    background-color: ${({ themeColor }) => themeColor};
    border-radius: 8px;
    height: 100%;
    width: 4px;
    @media only screen and (max-width: 1079px) {
      left: 16px;
    }
  }
`;

const HeadingWrapper = styled(FlexDiv)`
  @media only screen and (max-width: 1079px) {
    padding: 0 ${({ mobilePadding }) => mobilePadding};
    ${({ isTestimonial }) =>
      isTestimonial &&
      `
    max-width:calc(100% - 80px);
    `}
  }
`;
